export const sortOptionValues = [
  "relevance",
  "tsupdate_desc",
  "tsupdate_asc",
  "tscreate_desc",
  "tscreate_asc",
] as const;

export type SortOptionValue = (typeof sortOptionValues)[number];

export type SortOption = {
  value: SortOptionValue;
  i18n: string;
  field: "relevance" | "tsupdate" | "tscreate";
  order?: "asc" | "desc";
};
export const sortOptions: SortOption[] = [
  { field: "relevance", value: "relevance", i18n: "sort_by_relevance" },
  { field: "tsupdate", order: "desc", value: "tsupdate_desc", i18n: "sort_by_updated_at_desc" },
  { field: "tsupdate", order: "asc", value: "tsupdate_asc", i18n: "sort_by_updated_at_asc" },
  { field: "tscreate", order: "desc", value: "tscreate_desc", i18n: "sort_by_created_at_desc" },
  { field: "tscreate", order: "asc", value: "tscreate_asc", i18n: "sort_by_created_at_asc" },
] as const;

export type ConvertCommand = "extract_march" | "or" | "and";

export type ConvertCommandOption = {
  value: ConvertCommand;
  labelI18n: string;
  enabledSingleWord: boolean;
};

export const convertCommandOptions: ConvertCommandOption[] = [
  {
    value: "extract_march",
    labelI18n: "search_form_option_heading_convert_exact_match",
    enabledSingleWord: true,
  },
  {
    value: "and",
    labelI18n: "search_form_option_heading_convert_and",
    enabledSingleWord: false,
  },
  {
    value: "or",
    labelI18n: "search_form_option_heading_convert_or",
    enabledSingleWord: false,
  },
] as const;
